import DetailMainPointChartField from './fields/Detail/MainPointChartField.vue'

const mainPointChartFieldSetup = (app) => {
  app.component('detail-main-point-chart-field', DetailMainPointChartField)
  // Nova still resolves form/index components — provide empty shells.
  app.component('form-main-point-chart-field', { render: () => null })
  app.component('index-main-point-chart-field', { render: () => null })
}

export { mainPointChartFieldSetup }
